import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const SCANS_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'scans'

export const scans = Object.freeze({
  async uploadItem(data) {
    const response = await axiosInstance.post(`${SCANS_URL}/${ENTITY}/`, data)
    return response.data
  },
})
